import SeedSelector from '../SeedSelector'
import Button from '../Button'
import { useI18n } from '../../i18n/I18nProvider'

function SeedInventory({ 
  seedInventory, 
  pendingSeedType, 
  onSelectSeed, 
  onCancelSeed 
}) {
  const { t } = useI18n()
  // Ici on affiche toutes les graines de l'inventaire (tous types confondus)
  const totalInventorySeeds = Object.values(seedInventory || {}).reduce((sum, qty) => sum + qty, 0)

  return (
    <div className="bg-white rounded-xl shadow-lg p-6">
      <h3 className="text-xl font-bold mb-4">{t('seedInventory.title')}</h3>
      <div className="flex items-center justify-between mb-4">
        <span className="text-gray-600">{t('seedInventory.availableAllSeeds')}</span>
        <span className="text-2xl font-bold text-green-600">{totalInventorySeeds}</span>
      </div>

      {!pendingSeedType && (
        <SeedSelector onPlant={onSelectSeed} />
      )}
      
      {pendingSeedType && (
        <div className="mt-4 flex gap-4">
          <Button
            onClick={onCancelSeed}
            variant="secondary"
            className="flex-1"
          >
            {t('seedInventory.cancel')}
          </Button>
        </div>
      )}
    </div>
  )
}

export default SeedInventory
